import { getLocalImagePath } from "@/lang/getLocalImg.js";
export default {
  // 响应点击事件，触发父组件做出相应的动作
  emits: ["onHandleGotoFunction"],
  data() {
    return {
      buttonimg: getLocalImagePath('home_imagetrans_button') //开始拼装按钮
    };
  },

  props: {
    // 这里是接收父组件传递过来的参数
    buttonbackgroud_img: {
      type: String,
      default: ''
    },
    // 选择框背景图片
    selectbox_img: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if (this.buttonbackgroud_img != '') {
      this.buttonimg = this.buttonbackgroud_img;
    }
  },
  methods: {
    // 跳转到对应的功能页面 图像转换或者是预置模型
    gotoFunction() {
      this.$emit("onHandleGotoFunction");
    }
  }
};